import { useEffect } from "react";
import AdminHeader from "@/features/admin/components/adminHeader";
import Sider from "@/features/admin/components/sider";
import { useAuth } from "@/features/login/hooks/useAuth";
import { useBrandingTheme } from "@/features/branding/hooks/BrandingProvider";
import BrandingService from "@/features/branding/services/BrandingService";
import { Outlet } from "react-router";

const brandingService = new BrandingService();

export default function AdminLayout() {
  const { user } = useAuth();
  const { apply } = useBrandingTheme();

  // Once authenticated, apply the user's tenant branding (inherited from the root Admin).
  useEffect(() => {
    if (!user) return;
    let ignore = false;
    brandingService
      .getInherited()
      .then((b) => {
        if (!ignore && b) apply(b);
      })
      .catch(() => {});
    return () => {
      ignore = true;
    };
  }, [user, apply]);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar Navigation */}
      {user ? <Sider user={user} /> : null}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Main Content */}
        {user ? <AdminHeader user={user} /> : null}

        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
